export const ConsumerSegments = [
  'Men',
  'Women',
  'Plus/Curve',
  'Shoes',
  'Accessories',
  'Kids',
  'Beauty',
  'Pets',
  'Home',
];

export const Categories = [
  'Allover Printed Woven',
  'Basic Knit Tops',
  'Beauty',
  'Blazers',
  'Bodysuits',
  'Boxers/Briefs',
  'Boys',
  'Casual Jackets',
  'Coveralls',
  'Denim Jackets',
  'Denim Shorts',
  'Dresses',
  'Eyewear',
  'Footwear',
  'Girls',
  'Hand Bags',
  'Hats',
  'Home Accessories',
  'Home Bed & Bath',
  'Jackets/Outerwear',
  'Jeans',
  'Jewelry',
  'Jumpsuits',
  'Knit Tops',
  'Leggings',
  'Lingerie',
  'Loungewear',
  'Luggage/Travel Gear',
  'Matching Sets',
  'Non Denim Bottoms',
  'NonDenim Shorts',
  'Novelty Accessories',
  'Pants',
  'Rompers',
  'Scarves',
  'Screen Tops',
  'Scrubs',
  'Shirts',
  'Shoes',
  'Skirts',
  'Sleepwear',
  'Socks',
  'Special Occasion Dresses',
  'Suiting',
  'Sunglasses',
  'Sweaters',
  'Swimwear',
  'Tech',
  'Technical Sport Gear',
  'True Cold Weather',
  'Watches',
  'Woven Tops',
  'All',
];

export const Classifications = ['knit', 'woven', 'sweater', 'denim'];

export const Regions = [
  'USA',
  'Mexico',
  'Central America',
  'South America',
  'Carribean',
  'Africa',
  'Europe',
  'South East Asia',
  'China',
  'Other',
];

export const CoreCompetencies = [
  'Active wear fabric',
  'Alternative fabric',
  'Antimicrobial fabric',
  'Appliqué',
  'Art Direction',
  'Binding',
  'Bit Map',
  'Blank hoodie',
  'Blank tee',
  'Burning a Screen',
  'Burn Wash',
  'Burnout',
  'Camera-Ready Art',
  'Caustic wash',
  'Color Separation',
  'Denim',
  'Discharge Inks',
  'Discharge Prints',
  'Engineered print',
  'Enzyme Wash',
  'ePerfomance',
  'Flat Felled Seams',
  'Flat Needle Stitch',
  'Fleece',
  'French Seams',
  'French Terry',
  'Garment Dye',
  'Graphic Designers',
  'Hand Beading',
  'Hand Sanding',
  'Heat sealed',
  'Heat tranfers',
  'In House Designer',
  'Intarsia',
  'Invisible Zippers',
  'Jacquard',
  'Laser Whiskers',
  'Madras',
  'Marbled Wash',
  'Metallic Inks',
  'Moisture wicking',
  'Neon Dye',
  'Overdye',
  'Ozone Wash',
  'Patching & Repair',
  'Pigment Dye',
  'Polar fleece',
  'Potassium Spray',
  'Powder Dyeing',
  'Power Stretch',
  'Pre-Wash',
  'Private label',
  'Reactive Dye',
  'Resin',
  'Sandblasting',
  'Scalloped Technique',
  'Seamless',
  'Shearling',
  'Sherpa',
  'Stonewash',
  'Sublimation',
  'Tie Dye',
  'Tinting',
  'Trend Reports',
  'Upcycling',
  'UV Inks',
  'UV Protection',
  'Vintage wash',
  'Water repellent',
  'Water resistant',
  'Water-Based Inks',
  'Wet-on-Wet Printing',
  'Wrinkle free',
  'Yarn dye',
];

export const TextInputFields = [
  'company_name',
  'first_name',
  'last_name',
  'email',
  'phone',
];

export const SelectInputFields = [
  'consumer_segment',
  'fabric_classification',
  'product_type',
  'region',
  'country',
];

export const SwitchFields = [
  'full_package_vendor',
  'third_party_compliant',
  'third_party_garment_testing',
  'plus_size_manufacturer',
  'stock_goods',
  'fn_trim_capability',
  'cut_to_order',
  'exclusive_style_manufacturer',
  'product_development_capabilities',
  'pattern_maker',
];
